/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar } from "@chakra-ui/avatar";
import { IconButton } from "@chakra-ui/button";
import { CloseIcon } from "@chakra-ui/icons";
import { Box, Flex, Heading } from "@chakra-ui/layout";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

export const MemberView = ({ isAdmin, clubRef }) => {
	const [members, setMembers] = useState([]);
	const [error, setError] = useState("");
	const history = useHistory();

	useEffect(() => {
		const unsub = clubRef.onSnapshot(async club => {
			if (!club) return history.push("/main");
			if (!club.data().members || club.data().members.length === 0)
				return setError(
					"This club currently has no members, invite your friends!"
				);

			const constructUrl =
				"https://us-central1-kyoi-dev.cloudfunctions.net/getUser?uid=" +
				club.data().members.join(",");
			const realMembers = await fetch(constructUrl);
			setMembers(await realMembers.json());
		});

		return unsub;
	}, [clubRef]);

	const removeUser = async uid => {
		const data = await clubRef.get();
		const members = data.data().members;

		const newOnes = members.filter(muid => muid !== uid);

		clubRef.update({ members: newOnes });
	};

	return (
		<Box>
			{error !== "" ? (
				<Heading size="md">{error}</Heading>
			) : (
				members.length > 0 && (
					<Box>
						{members.map((member, key) => (
							<Flex
								key={key}
								bgColor="gray.100"
								padding="2.2rem"
								rounded="lg"
								justifyContent="space-between"
								alignItems="center"
								mb={5}
							>
								<Flex alignItems="center">
									<Avatar />
									<Heading size="md" ml={5} isTruncated>
										{member.displayName}
									</Heading>
								</Flex>
								{isAdmin && (
									<IconButton
										rounded="full"
										icon={<CloseIcon />}
										colorScheme="red"
										onClick={() => removeUser(member.uid)}
									/>
								)}
							</Flex>
						))}
					</Box>
				)
			)}
		</Box>
	);
};
